;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/MegaMenuItem',["jquery", "eventManager", 'loglevel'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel')) :
    console && console.error('MegaMenuItem does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function MegaMenuItem(scope, clickMessagesTransmitting) {
        var self = this;
        Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

        //#region click messages transmitting registration
        if (clickMessagesTransmitting.length) {
            this.$scope.on("click", "a.dropdown-toggle.toggle-caret", function (e) {
                e.preventDefault();

                clickMessagesTransmitting.forEach(function (eventName) {
                    log.debug("MegaMenuItem raises message: \'%s\'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return 1;
            });
        }
        //#endregion
    }

    MegaMenuItem.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new MegaMenuItem(args.scope, args.ClickMessagesTransmitting || []);
    };

    return MegaMenuItem;
}));
